import { GET_SUB_CATEGORY } from "./types";
import axios from "axios";

export default params => async dispatch => {
  const res = await axios.get(`/api/post_sub_category/search`, {
    params: params
  });
  dispatch(getAsync(res.data));
};
const getAsync = data => ({
  type: GET_SUB_CATEGORY,
  payload: data
});
